import { mobileCSS } from '@measures/responsive'
import { css } from 'styled-components'
import { printCSS } from '@utils/style'

const bodyStyle = css`
  ${({
    theme: {
      fonts: { sourceSansPro },
    },
  }) => css`
    display: grid;
    grid-row-gap: 16px;
    align-items: flex-start;

    ul {
      padding-left: 1em;
    }

    ol {
      padding-left: 1.7em;
    }

    li,
    p {
      font-size: 19px;
      line-height: 1.5;

      ${mobileCSS(css`
        font-size: 18px;
      `)}

      ${printCSS(css`
        font-size: 14px;
      `)}
    }

    p {
      overflow: auto;
      &:empty {
        display: none;
      }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    ul,
    ol {
      margin: 0;
    }

    h1,
    h2 {
      font-family: ${sourceSansPro};
      font-weight: 700;
      font-size: 24px;
      line-height: 1.25;
      ${printCSS(css`
        font-size: 18px;
      `)}
    }

    h3 {
      font-size: 22px;
      line-height: 1.3;
      ${printCSS(css`
        font-size: 16px;
      `)}
    }

    h4 {
      font-size: 17px;
      line-height: 1.5;
      ${printCSS(css`
        font-size: 14px;
      `)}
    }

    > *:not(div):not(aside) + h1,
    > *:not(div):not(aside) + h2,
    > *:not(div):not(aside) + h3,
    > *:not(div):not(aside) + h4 {
      margin-top: 16px;
    }

    > div {
      margin-top: 16px;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    > aside {
      margin-top: 16px;
      margin-bottom: 16px;
      &:last-child {
        margin-bottom: 0;
      }
    }

    > div + div,
    > div + aside > div + h1,
    > div + h2,
    > div + h3,
    > div + h4 {
      margin-top: 0;
    }

    > aside + div,
    > aside + aside > aside + h1,
    > aside + h2,
    > aside + h3,
    > aside + h4 {
      margin-top: 0;
    }
  `}
`

export { bodyStyle }
